import { Menu } from 'lucide-react';
import { Link } from 'react-router';
import logo from '../assets/sm-full-logo-light.png';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export const MobileHeader = ({ onMenuClick }: MobileHeaderProps) => {
  return (
    // px-5 matches the page gutter; the menu button pulls in by -mr-2.5 so its
    // 20px icon sits flush with the content's right edge.
    <header className="flex h-12 shrink-0 items-center justify-between gap-3 border-b border-seeker-800 bg-seeker-950 px-5 lg:hidden">
      <Link
        to="/dashboard"
        aria-label="Solana Mobile home"
        className="flex items-center rounded-md py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:ring-offset-2 focus-visible:ring-offset-seeker-950"
      >
        <img src={logo} alt="Solana Mobile" className="h-[18px] w-auto" />
      </Link>
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Open menu"
        className="-mr-2.5 inline-flex size-10 items-center justify-center rounded-lg text-white transition-colors duration-150 hover:bg-white/5 active:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:ring-offset-2 focus-visible:ring-offset-seeker-950"
      >
        <Menu className="size-5" />
      </button>
    </header>
  );
};
